// src/utils/axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  //withCredentials: true,
  timeout: 5000,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    // Not Found
    if (status === 404) {
      if (!window.location.pathname.startsWith('/not-found')) {
        window.location.replace('/not-found');
      }
      return Promise.reject(error);
    }

    // それ以外はそのまま投げる
    return Promise.reject(error);
  }
);

export default axiosInstance;
